(function () {
    'use strict';

    angular.module("imApp").factory("selectCheckListAddService", ['$ihttp', function ($ihttp) {
        let service = {
            listCheckList: function (parms) {
                return $ihttp.post({
                    method: 260,
                    parameters: parms || {}
                });
            },
            saveToPrevious: function (item) {
                return $ihttp.post({
                    method: 261,
                    parameters: item
                });
            }
        };

        return service;
    }]);
})();
